/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

/* eslint-disable import/no-anonymous-default-export */
import { ApolloClient, InMemoryCache } from '@apollo/client';
import CONFIG from '../../config';

export default new ApolloClient({
  uri: CONFIG.graphCMSURI,
  cache: new InMemoryCache(),
  headers: {
    Authorization: `Bearer ${CONFIG.graphCMSToken}`
  }
});

